'use strict';

// Services
import ListModel from 'common/components/list/listModel.service';
import { validAccess } from 'accessControl';

const __endpoints = require('endpoints.service');

export default class SalaryComponentDailySupplementRulesList extends ListModel {
	constructor(reduxKey) {
		super(reduxKey);
		this.headers = [
			{
				name: 'minimum_hours',
				type: 'number',
				canAdd: true,
				canEdit: true,
			},
			{
				name: 'maximum_hours',
				type: 'number',
				canAdd: true,
				canEdit: true,
			},
			{
				name: 'break_hours',
				type: 'number',
				canAdd: true,
				canEdit: true,
			},
		];
		this.settings = {
			name: 'SalaryComponentDailySupplementRulesList',
			allowEmpty: true,
			alwaysRefresh: true,
			canAdd: true,
			canEdit: true,
			canDelete: true,
			canManipulate: () => validAccess(undefined, ['Salary Admin']),
			translationPath: 'SALARY.SALARY_COMPONENT_DAILY_SUPPLEMENT_RULES',
			endpoint: __endpoints.collection.salary.salary_component_daily_supplement_rules,
		};
		this.init();
		return this;
	}
}
